import React from "react";

import "./App.scss";

import { About, Footer, Header, Works, Skills } from "./container";

import { Navbar } from "./components";

const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Works />
      <Skills />

      <Footer />
    </div>
  );
};

export default App;
